module.exports = __webpack_public_path__ + "static/media/YM78_3.4f553d4f.jpg";